import { useI18n } from 'vue-i18n'

export const VEHICLE_STATUS_VALUES = {
  ACTIVE: 'ACTIVE',
  OUT_OF_SERVICE: 'OUT_OF_SERVICE',
} as const

const VEHICLE_STATUS_TRANSLATION_KEYS: Record<string, string> = {
  [VEHICLE_STATUS_VALUES.ACTIVE]: 'vehicleStatusActive',
  [VEHICLE_STATUS_VALUES.OUT_OF_SERVICE]: 'vehicleStatusOutOfService',
}

export function useVehicleStatuses() {
  const { t } = useI18n()

  const statusOptions = Object.values(VEHICLE_STATUS_VALUES).map((value) => ({
    title: t(VEHICLE_STATUS_TRANSLATION_KEYS[value]),
    value,
  }))

  const translateStatus = (value: string | null | undefined) => {
    if (!value) {
      return value
    }
    const key = VEHICLE_STATUS_TRANSLATION_KEYS[value]
    return key ? t(key) : value
  }

  return { statusOptions, translateStatus }
}
